export default "__VITE_ASSET__haeFybNY__"